import React from 'react';
import { motion } from 'framer-motion';
import MasonryGrid from '../components/MasonryGrid';
import { portfolioItems } from '../data/portfolioData';
const MotionDesignPortfolio = () => {
  const motionItems = portfolioItems.filter(item => {
    if (Array.isArray(item.category)) {
      return item.category.includes('Motion Design');
    }
    return item.category === 'Motion Design';
  });
  return <motion.div className="p-6" initial={{
    opacity: 0,
    x: 100
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -100
  }} transition={{
    duration: 0.5,
    ease: 'easeInOut'
  }} data-id="element-314">
      <MasonryGrid items={motionItems} data-id="element-315" />
    </motion.div>;
};
export default MotionDesignPortfolio;